import * as React from 'react';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType';
import { CloseS12 } from '../../../../icons';
import { useTagOnKeyDown } from '../../hooks';
import { getStyles } from './styles';
export var Tag = function Tag(props) {
  var children = props.children,
    onClose = props.onClose,
    size = props.size;
  var deviceType = useDeviceType();
  var onKeyDown = useTagOnKeyDown(onClose);
  var styles = getStyles(size ? size : deviceType === 'phone' ? 'M' : 'XS');
  return /*#__PURE__*/React.createElement("div", {
    className: styles['tag'],
    tabIndex: 0,
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['tag_content']
  }, children), /*#__PURE__*/React.createElement("div", {
    className: styles['tag_close'],
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseS12, {
    color: "gray_icons_100"
  })));
};
Tag.displayName = 'Tag';